import { useContext, useEffect, useState } from "react";
import "../../../../assets/css/customer/subscreens/home/MyHeroSection.css";
import axios from "axios";
import AppContext from "../../../../contexts/AppContext";

const MyHeroSection = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [hero, setHero] = useState([]);
  const [statValues, setStatValues] = useState({
    total_artisans: 0,
    avg_rating: 0,
    happy_customers: 0,
  });

  const viewHeroSection = () => {
    axios
      .get(`${baseUrl}/customer/hero/herosection`)
      .then((response) => {
        setHero(response.data.hero);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewStatCards = () => {
    axios
      .get(`${baseUrl}/statcard/viewStatCard`)
      .then((response) => {
        setStatValues({
          total_artisans: response.data.total_artisans,
          avg_rating: response.data.avg_rating,
          happy_customers: response.data.happy_customers,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewHeroSection();
    viewStatCards();
  }, []);

  const h = hero.find(
    (item) => item.is_active === 1 || item.is_active === true,
  );

  if (!h) return null;

  return (
    <div className="hero-section">
      {/* Background Pattern */}
      <div className="bg-pattern">
        <div className="dot-grid dot-grid-left"></div>
        <div className="dot-grid dot-grid-bottom"></div>
      </div>

      {/* Curved Lines */}
      <svg
        className="curved-lines"
        viewBox="0 0 1200 800"
        preserveAspectRatio="none"
      >
        <path className="curve-line line1" d="M 0,400 Q 300,200 600,400 T 1200,400" />
        <path className="curve-line line2" d="M 0,450 Q 300,250 600,450 T 1200,450" />
        <path className="curve-line line3" d="M 0,500 Q 300,300 600,500 T 1200,500" />
      </svg>

      {/* Bottom Wave */}
      <div className="bottom-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,50 Q300,0 600,50 T1200,50 L1200,120 L0,120 Z"
            fill="rgba(255, 133, 89, 0.05)"
          />
        </svg>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          {/* Left — Text */}
          <div className="text-section">
            <h1 className="hero-main-heading">
              <span style={{ display: "block" }}>{h.line1}</span>
              <span className="highlight-line">{h.line2}</span>
              <span className="gradient-text">{h.line3}</span>
            </h1>

            <p className="sub-text">{h.subtext}</p>

            {/* Trust Badges — icon/label static, value dynamic */}
            <div className="trust-badges">
              <div className="badge-item">
                <div className="badge-icon">✓</div>
                <span>{statValues.total_artisans}+ Artisans</span>
              </div>
              <div className="badge-item">
                <div className="badge-icon">★</div>
                <span>{statValues.avg_rating} Rating</span>
              </div>
              <div className="badge-item">
                <div className="badge-icon">♥</div>
                <span>{statValues.happy_customers}+ Happy Customers</span>
              </div>
            </div>
          </div>

          {/* Right — Images */}
          <div className="image-section">
            <div className="main-image-wrapper">
              <div className="image-glow"></div>
              <img
                src={`${baseUrlForFiles}/${h.mainImage}`}
                alt="Handmade Artisan"
                className="main-image"
              />
              <div className="image-frame"></div>
            </div>

            {Array.isArray(h.bubble_images) &&
              h.bubble_images.slice(0, 5).map((item, index) => (
                <div
                  key={item.id}
                  className={`floating-bubble bubble-${index + 1}`}
                >
                  <img
                    src={`${baseUrlForFiles}/${item.image_path}`}
                    alt={`Product ${index + 1}`}
                  />
                </div>
              ))}

            <div className="deco-element deco-circle-1"></div>
            <div className="deco-element deco-circle-2"></div>
            <div className="deco-element deco-square"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyHeroSection;